import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
    <div className='copyright'>
     Copyright &copy; {new Date().getFullYear()} Nagacor181 is an international registered trademark. All rights reserved.
    </div>
    </footer>
  )
}

export default Footer